<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 4.5904C2 3.17592 3.13358 2 4.56517 2H19.4359C20.8684 2 22 3.17681 22 4.5904V5.52644C22 6.42941 21.6569 7.2995 21.041 7.95596L16.1944 13.1094L16.1837 13.1206C15.4399 13.8874 15.0201 14.926 15.0201 16.0114V18.2984C15.0201 19.1386 14.5653 19.9201 13.8229 20.3255L11.0613 21.8304C10.1049 22.3498 8.99905 21.6306 8.99905 20.5952V16.0233C8.99905 14.9595 8.59423 13.9405 7.87638 13.1767C7.85218 13.1555 7.8289 13.1331 7.80664 13.1094L2.96089 7.95685C2.34325 7.30008 2 6.42952 2 5.52644V4.5904ZM9.20341 11.6753C9.22027 11.6903 9.23668 11.706 9.25259 11.7223C10.3717 12.868 10.9991 14.4139 10.9991 16.0233V19.5866L12.8643 18.5702C12.9549 18.5206 13.0201 18.4181 13.0201 18.2984V16.0114C13.0201 14.4149 13.6361 12.8775 14.7426 11.7338L19.5824 6.58758C19.8487 6.30367 20 5.92351 20 5.52644V4.5904C20 4.24892 19.7316 4 19.4359 4H4.56517C4.26858 4 4 4.24981 4 4.5904V5.52644C4 5.92342 4.15113 6.30309 4.41782 6.58668L9.20341 11.6753Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
